var map = {
	"./theme_gold/images/10_gift.png": "955b",
	"./theme_gold/images/1_gift.png": "2bf1",
	"./theme_gold/images/2_gift.png": "bc8b",
	"./theme_gold/images/3_gift.png": "1719",
	"./theme_gold/images/4_gift.png": "5b36",
	"./theme_gold/images/5_gift.png": "22ea",
	"./theme_gold/images/6_gift.png": "1518",
	"./theme_gold/images/7_gift.png": "df0a",
	"./theme_gold/images/8_gift.png": "6d53",
	"./theme_gold/images/9_gift.png": "c68c",
	"./theme_gold/images/Angle-left-g.png": "7294",
	"./theme_gold/images/Angle-left.png": "407c",
	"./theme_gold/images/Angle-right-g.png": "6363",
	"./theme_gold/images/Angle-right.png": "7040",
	"./theme_gold/images/BackToTop.png": "068f",
	"./theme_gold/images/Ellipse 264.png": "938b",
	"./theme_gold/images/LogoLoading_circle01.png": "8fe7",
	"./theme_gold/images/LogoLoading_circle02.png": "0b79",
	"./theme_gold/images/LogoLoading_katsu.png": "bf62",
	"./theme_gold/images/about_bg04.png": "0ae5",
	"./theme_gold/images/bank-card.png": "f934",
	"./theme_gold/images/bg-masthead-mb.png": "3128",
	"./theme_gold/images/bg-masthead.png": "45df",
	"./theme_gold/images/bg_brush.png": "ad51",
	"./theme_gold/images/bg_repeat.png": "a63d",
	"./theme_gold/images/bg_top.png": "7453",
	"./theme_gold/images/btc.png": "eab0",
	"./theme_gold/images/ch_logo.png": "1f60",
	"./theme_gold/images/check-on.png": "aac5",
	"./theme_gold/images/collect.png": "987c",
	"./theme_gold/images/collect_full.png": "14c4",
	"./theme_gold/images/completed.png": "a921",
	"./theme_gold/images/daily-attend.png": "d3ab",
	"./theme_gold/images/db_gift_left.png": "d01c",
	"./theme_gold/images/db_gift_right.png": "5744",
	"./theme_gold/images/db_hero_img_mb.png": "c127",
	"./theme_gold/images/db_hero_img_pc.png": "104d",
	"./theme_gold/images/db_icon_coin.png": "5b5c",
	"./theme_gold/images/db_icon_lock.png": "4e5e",
	"./theme_gold/images/en_logo.png": "4d1a",
	"./theme_gold/images/event.png": "d8d7",
	"./theme_gold/images/event_specail_deposit_bg3.png": "462e",
	"./theme_gold/images/footer_gaming1.png": "2398",
	"./theme_gold/images/footer_gaming2.png": "8058",
	"./theme_gold/images/footer_gaming3.png": "890e",
	"./theme_gold/images/footer_gaming4.png": "18b2",
	"./theme_gold/images/fortunewheel.png": "c281",
	"./theme_gold/images/friend_promo.png": "f7ff",
	"./theme_gold/images/giftbox.png": "4db4",
	"./theme_gold/images/history.png": "89d8",
	"./theme_gold/images/home-arrow-left.png": "914e",
	"./theme_gold/images/home-arrow-right.png": "4bb9",
	"./theme_gold/images/icon-account.png": "1dc5",
	"./theme_gold/images/icon-add.png": "dab3",
	"./theme_gold/images/icon-alert-kyc.png": "d9bc",
	"./theme_gold/images/icon-alert.png": "bc92",
	"./theme_gold/images/icon-arrow-down-2.png": "3e9b",
	"./theme_gold/images/icon-arrow-down-3.png": "a110",
	"./theme_gold/images/icon-arrow-down-4-disabled.png": "8a77",
	"./theme_gold/images/icon-arrow-down-4.png": "7b08",
	"./theme_gold/images/icon-arrow-down-gold.png": "ab44",
	"./theme_gold/images/icon-arrow-down.png": "b346",
	"./theme_gold/images/icon-arrow-dropdown.png": "d851",
	"./theme_gold/images/icon-arrow-right.png": "28fb",
	"./theme_gold/images/icon-check-black.png": "bf96",
	"./theme_gold/images/icon-check.png": "cac4",
	"./theme_gold/images/icon-checked.png": "b407",
	"./theme_gold/images/icon-close-black.png": "ed52",
	"./theme_gold/images/icon-close.png": "4297",
	"./theme_gold/images/icon-close_index_phone.png": "b998",
	"./theme_gold/images/icon-coin.png": "2879",
	"./theme_gold/images/icon-copy-2.png": "9df4",
	"./theme_gold/images/icon-copy.png": "96f0",
	"./theme_gold/images/icon-crown.png": "6cb3",
	"./theme_gold/images/icon-date.png": "1e05",
	"./theme_gold/images/icon-detail.png": "61c1",
	"./theme_gold/images/icon-diamond.png": "8292",
	"./theme_gold/images/icon-download.png": "5225",
	"./theme_gold/images/icon-favorite-active.png": "6a1d",
	"./theme_gold/images/icon-favorite.png": "afeb",
	"./theme_gold/images/icon-filter.png": "b706",
	"./theme_gold/images/icon-flag.png": "3935",
	"./theme_gold/images/icon-game-search.png": "0bec",
	"./theme_gold/images/icon-header-toggler.png": "3212",
	"./theme_gold/images/icon-home.png": "7304",
	"./theme_gold/images/icon-info.png": "13d5",
	"./theme_gold/images/icon-invite-bonus.png": "8015",
	"./theme_gold/images/icon-invite-promo.png": "aeda",
	"./theme_gold/images/icon-invite-weekly.png": "e0d4",
	"./theme_gold/images/icon-kyc-add.png": "814a",
	"./theme_gold/images/icon-kyc-close.png": "3f94",
	"./theme_gold/images/icon-kyc-open.png": "f957",
	"./theme_gold/images/icon-lock.png": "c9ed",
	"./theme_gold/images/icon-member-active.png": "5ee8",
	"./theme_gold/images/icon-member.png": "a63db",
	"./theme_gold/images/icon-nav-home.png": "0544",
	"./theme_gold/images/icon-notice.png": "3323",
	"./theme_gold/images/icon-password.png": "5876",
	"./theme_gold/images/icon-phone-active.png": "3b9d",
	"./theme_gold/images/icon-phone.png": "c6fe",
	"./theme_gold/images/icon-qrcode.png": "b3df",
	"./theme_gold/images/icon-real-name.png": "bc12",
	"./theme_gold/images/icon-recommend.png": "01f3",
	"./theme_gold/images/icon-refresh.png": "6426",
	"./theme_gold/images/icon-register-success.png": "b335",
	"./theme_gold/images/icon-search.png": "735c",
	"./theme_gold/images/icon-slot-select.png": "d9bcc",
	"./theme_gold/images/icon-slot.png": "9e01",
	"./theme_gold/images/icon-usdt.png": "8ff3",
	"./theme_gold/images/icon_allgames.png": "7079",
	"./theme_gold/images/icon_awesome_bitcoin.png": "bdb6",
	"./theme_gold/images/icon_bell.png": "9dd8",
	"./theme_gold/images/icon_check_white.png": "ac67",
	"./theme_gold/images/icon_copy_white.png": "428d",
	"./theme_gold/images/icon_download_white.png": "3ec2",
	"./theme_gold/images/icon_email.png": "becd",
	"./theme_gold/images/icon_ig.png": "d816",
	"./theme_gold/images/icon_img_01.png": "f154",
	"./theme_gold/images/icon_img_03.png": "0f71",
	"./theme_gold/images/icon_img_04.png": "ab60",
	"./theme_gold/images/icon_img_05.png": "cbeb",
	"./theme_gold/images/icon_img_06.png": "ecc1",
	"./theme_gold/images/icon_img_07.png": "74cc",
	"./theme_gold/images/icon_img_08.png": "abc5",
	"./theme_gold/images/icon_img_09.png": "93e2",
	"./theme_gold/images/icon_img_10.png": "620a",
	"./theme_gold/images/icon_img_11.png": "b86d",
	"./theme_gold/images/icon_img_12.png": "d245",
	"./theme_gold/images/icon_img_13.png": "aebc",
	"./theme_gold/images/icon_img_14.png": "c0f5",
	"./theme_gold/images/icon_img_15.png": "384f",
	"./theme_gold/images/icon_metro_credit_card.png": "1727",
	"./theme_gold/images/icon_payment_bankomat.png": "ca5d",
	"./theme_gold/images/icon_promo_check.png": "1ee0",
	"./theme_gold/images/icon_promo_check_v2.png": "7b00",
	"./theme_gold/images/icon_simple_electron.png": "00ec",
	"./theme_gold/images/icon_tab_favorite.png": "20a5",
	"./theme_gold/images/icon_tag_hot.png": "ac63",
	"./theme_gold/images/icon_tag_new.png": "0dde",
	"./theme_gold/images/icon_tag_noBonus.png": "f329",
	"./theme_gold/images/icon_twitter.png": "fe57",
	"./theme_gold/images/icon_youtube.png": "a7a4",
	"./theme_gold/images/image-bank.png": "3fdc",
	"./theme_gold/images/image-upload.png": "efe2",
	"./theme_gold/images/japan.png": "3686",
	"./theme_gold/images/jp_logo.png": "930c",
	"./theme_gold/images/leave.png": "3876",
	"./theme_gold/images/live.png": "cf51",
	"./theme_gold/images/login-left.png": "f4e9",
	"./theme_gold/images/logo.png": "bbcd",
	"./theme_gold/images/logo_ft.png": "d16c",
	"./theme_gold/images/logo_katsuwin.png": "c293",
	"./theme_gold/images/mall-invite-image.png": "26be",
	"./theme_gold/images/mall-product-image.png": "d8be",
	"./theme_gold/images/money_pop.png": "b7b7",
	"./theme_gold/images/my-account.png": "88ef",
	"./theme_gold/images/nav-bottom-deposit-active.png": "5a42",
	"./theme_gold/images/nav-bottom-deposit.png": "bc5a",
	"./theme_gold/images/nav-bottom-event.png": "5f86",
	"./theme_gold/images/nav-bottom-event.webp-active.png": "9096",
	"./theme_gold/images/nav-bottom-home-active.png": "d640",
	"./theme_gold/images/nav-bottom-home-mobile-index.png": "fb75",
	"./theme_gold/images/nav-bottom-home.png": "65e1",
	"./theme_gold/images/nav-bottom-my-active.png": "65c9",
	"./theme_gold/images/nav-bottom-my.png": "c4fe",
	"./theme_gold/images/nav-bottom-offers-active.png": "3854",
	"./theme_gold/images/nav-bottom-offers.png": "47f5",
	"./theme_gold/images/nav-bottom-recommend-active.png": "2ba4",
	"./theme_gold/images/nav-bottom-recommend.png": "f537",
	"./theme_gold/images/nav-bottom-vip-active.png": "4bf6",
	"./theme_gold/images/nav-bottom-vip.png": "5b65",
	"./theme_gold/images/new_guide.png": "32ff",
	"./theme_gold/images/no-data.png": "9c8b",
	"./theme_gold/images/oncasy_logo.png": "55c9",
	"./theme_gold/images/pachislot.png": "54a9",
	"./theme_gold/images/program.png": "f10a",
	"./theme_gold/images/rank-1st.png": "05eb",
	"./theme_gold/images/rank-2nd.png": "8429",
	"./theme_gold/images/rank-3rd.png": "0128",
	"./theme_gold/images/register-logo.png": "569a",
	"./theme_gold/images/shop.png": "b51c",
	"./theme_gold/images/skill.png": "065d",
	"./theme_gold/images/slots.png": "da60",
	"./theme_gold/images/spin_wheel_bg_lt.png": "9952",
	"./theme_gold/images/spin_wheel_bg_rt.png": "cd50",
	"./theme_gold/images/stake-logo.png": "039f",
	"./theme_gold/images/structure01.png": "9d7b",
	"./theme_gold/images/structure02.png": "ac4c",
	"./theme_gold/images/structure03.png": "ad6a",
	"./theme_gold/images/sup/account_mb_01.png": "c22e",
	"./theme_gold/images/sup/account_mb_02.png": "8477",
	"./theme_gold/images/sup/account_mb_03.png": "1f73",
	"./theme_gold/images/sup/account_mb_04.png": "b490",
	"./theme_gold/images/sup/account_mb_05.png": "3e9e",
	"./theme_gold/images/sup/account_mb_06.png": "9cc8",
	"./theme_gold/images/sup/account_pc_01.png": "8452",
	"./theme_gold/images/sup/account_pc_02.png": "a174",
	"./theme_gold/images/sup/account_pc_03.png": "4e7a",
	"./theme_gold/images/sup/account_pc_04.png": "6543",
	"./theme_gold/images/sup/account_pc_05.png": "b1b8",
	"./theme_gold/images/sup/account_pc_06.png": "0f15",
	"./theme_gold/images/sup/account_pc_07.png": "dd3a",
	"./theme_gold/images/sup/account_pc_08.png": "1e33",
	"./theme_gold/images/sup/binding_mb_tab_01.png": "7300",
	"./theme_gold/images/sup/binding_mb_tab_02.png": "5f89",
	"./theme_gold/images/sup/binding_mb_tab_03.png": "3846",
	"./theme_gold/images/sup/binding_mb_tab_04.png": "3c2d",
	"./theme_gold/images/sup/binding_mb_tab_05.png": "c0c5",
	"./theme_gold/images/sup/binding_mb_tab_06.png": "e364",
	"./theme_gold/images/sup/binding_pc_tab_01.png": "5e35",
	"./theme_gold/images/sup/binding_pc_tab_02.png": "b9f3",
	"./theme_gold/images/sup/binding_pc_tab_03.png": "cc8c",
	"./theme_gold/images/sup/binding_pc_tab_04.png": "a632",
	"./theme_gold/images/sup/binding_pc_tab_05.png": "9799",
	"./theme_gold/images/sup/binding_pc_tab_06.png": "7be0",
	"./theme_gold/images/sup/coupon_mb_tab_01.png": "9d4a",
	"./theme_gold/images/sup/coupon_mb_tab_02.png": "7111",
	"./theme_gold/images/sup/coupon_pc_tab_01.png": "e605",
	"./theme_gold/images/sup/coupon_pc_tab_02.png": "ec74",
	"./theme_gold/images/sup/event_mb_tab_01.png": "35d2",
	"./theme_gold/images/sup/event_mb_tab_02.png": "a656",
	"./theme_gold/images/sup/event_mb_tab_03.png": "9b42",
	"./theme_gold/images/sup/event_pc_tab_01.png": "466d",
	"./theme_gold/images/sup/event_pc_tab_02.png": "7ded",
	"./theme_gold/images/sup/event_pc_tab_03.png": "6e85",
	"./theme_gold/images/sup/login_tab01_01.png": "4c3c",
	"./theme_gold/images/sup/login_tab01_02.png": "4e58",
	"./theme_gold/images/sup/login_tab01_03.png": "3baf",
	"./theme_gold/images/sup/login_tab01_04.png": "84c7",
	"./theme_gold/images/sup/login_tab01_05.png": "0828",
	"./theme_gold/images/sup/login_tab02_02.png": "fcf8",
	"./theme_gold/images/sup/login_tab02_03.png": "2a37",
	"./theme_gold/images/sup/login_tab02_04.png": "f922",
	"./theme_gold/images/sup/login_tab02_05.png": "7219",
	"./theme_gold/images/sup/login_tab03_01.png": "162e",
	"./theme_gold/images/sup/login_tab03_02.png": "a51c",
	"./theme_gold/images/sup/login_tab03_03.png": "7b3c",
	"./theme_gold/images/sup/login_tab03_04.png": "fe16",
	"./theme_gold/images/sup/login_tab03_05.png": "6142",
	"./theme_gold/images/sup/login_tab04_02.png": "3107",
	"./theme_gold/images/sup/login_tab04_03.png": "0b7b",
	"./theme_gold/images/sup/login_tab04_04.png": "43d26",
	"./theme_gold/images/sup/login_tab04_05.png": "97b5",
	"./theme_gold/images/sup/payment_mb_01.png": "82ad",
	"./theme_gold/images/sup/payment_mb_02.png": "bb0f",
	"./theme_gold/images/sup/payment_mb_03.png": "daa3",
	"./theme_gold/images/sup/payment_mb_04.png": "aba6",
	"./theme_gold/images/sup/payment_mb_05.png": "e6e3",
	"./theme_gold/images/sup/payment_mb_06.png": "1d65",
	"./theme_gold/images/sup/payment_mb_07.png": "cb86",
	"./theme_gold/images/sup/payment_mb_08.png": "2e45",
	"./theme_gold/images/sup/payment_mb_09.png": "7d2b",
	"./theme_gold/images/sup/payment_mb_10.png": "c004",
	"./theme_gold/images/sup/payment_mb_11.png": "ce16",
	"./theme_gold/images/sup/payment_pc_01.png": "905c",
	"./theme_gold/images/sup/payment_pc_02.png": "a1ed",
	"./theme_gold/images/sup/payment_pc_03.png": "ed03",
	"./theme_gold/images/sup/payment_pc_04.png": "eef8",
	"./theme_gold/images/sup/payment_pc_05.png": "f8e3",
	"./theme_gold/images/sup/payment_pc_06.png": "fd8a",
	"./theme_gold/images/sup/payment_pc_07.png": "551e",
	"./theme_gold/images/sup/payment_pc_08.png": "4cb7",
	"./theme_gold/images/sup/payment_pc_09.png": "2ca3",
	"./theme_gold/images/sup/payment_pc_10.png": "774d",
	"./theme_gold/images/sup/payment_pc_11.png": "a772",
	"./theme_gold/images/sup/payment_pc_12.png": "bdd6",
	"./theme_gold/images/sup/register_mb_01.png": "1e3e",
	"./theme_gold/images/sup/register_mb_02.png": "f5d5",
	"./theme_gold/images/sup/register_mb_03.png": "7321",
	"./theme_gold/images/sup/register_mb_04.png": "3965",
	"./theme_gold/images/sup/register_mb_05.png": "7f1a",
	"./theme_gold/images/sup/register_pc_01.png": "95c8",
	"./theme_gold/images/sup/register_pc_02.png": "724b",
	"./theme_gold/images/sup/register_pc_03.png": "4996",
	"./theme_gold/images/sup/register_pc_04.png": "cf85",
	"./theme_gold/images/sup/register_pc_05.png": "6ead",
	"./theme_gold/images/sup/shop_mb_tab_01.png": "0aca",
	"./theme_gold/images/sup/shop_mb_tab_02.png": "6ab9",
	"./theme_gold/images/sup/shop_pc_tab_01.png": "96e2",
	"./theme_gold/images/sup/shop_pc_tab_02.png": "3afa",
	"./theme_gold/images/sup/table.png": "112d",
	"./theme_gold/images/sup/vip_mb_tab_01.png": "fbd7",
	"./theme_gold/images/sup/vip_mb_tab_02.png": "5e2d",
	"./theme_gold/images/sup/vip_mb_tab_03.png": "8c80",
	"./theme_gold/images/sup/vip_pc_tab_01.png": "4f7b",
	"./theme_gold/images/sup/vip_pc_tab_02.png": "b8ee",
	"./theme_gold/images/sup/wallet_mb_01.png": "f2cf",
	"./theme_gold/images/sup/wallet_mb_02.png": "e2f4",
	"./theme_gold/images/sup/wallet_mb_03.png": "1c8c",
	"./theme_gold/images/sup/wallet_mb_04.png": "9b3b",
	"./theme_gold/images/sup/wallet_mb_05.png": "ed58",
	"./theme_gold/images/sup/wallet_mb_06.png": "60b2",
	"./theme_gold/images/sup/wallet_pc_01.png": "ad88",
	"./theme_gold/images/sup/wallet_pc_02.png": "a184",
	"./theme_gold/images/sup/wallet_pc_03.png": "1320",
	"./theme_gold/images/sup/wallet_pc_04.png": "2d6a",
	"./theme_gold/images/sup/wallet_pc_05.png": "2b1c",
	"./theme_gold/images/sup/wallet_pc_06.png": "91fc",
	"./theme_gold/images/sup/wallet_pc_07.png": "56f7",
	"./theme_gold/images/sup/wallet_pc_08.png": "dbae",
	"./theme_gold/images/terms-bg.png": "fa81",
	"./theme_gold/images/title-championship.png": "579d",
	"./theme_gold/images/top_up.png": "20d1",
	"./theme_gold/images/useful_link/icon_FAQ.png": "7cef",
	"./theme_gold/images/useful_link/icon_account_binding.png": "679f",
	"./theme_gold/images/useful_link/icon_confirm_method.png": "bfc0",
	"./theme_gold/images/useful_link/icon_coupon.png": "8f9f",
	"./theme_gold/images/useful_link/icon_deposit_withdraw.png": "6942",
	"./theme_gold/images/useful_link/icon_event_bonus.png": "9679",
	"./theme_gold/images/useful_link/icon_login.png": "5314",
	"./theme_gold/images/useful_link/icon_login_method.png": "b8c0",
	"./theme_gold/images/useful_link/icon_recommended_games.png": "8068",
	"./theme_gold/images/useful_link/icon_self_restriction.png": "cd56",
	"./theme_gold/images/useful_link/icon_shop.png": "089f",
	"./theme_gold/images/useful_link/icon_vip_class_upgrading.png": "13d8",
	"./theme_gold/images/useful_link/icon_wallet.png": "50f2",
	"./theme_gold/images/verify.png": "8b0d",
	"./theme_gold/images/vip-24-hours.png": "2c23",
	"./theme_gold/images/vip-arrow-left.png": "48da",
	"./theme_gold/images/vip-arrow-right.png": "275d",
	"./theme_gold/images/vip-coin-stack.png": "3313",
	"./theme_gold/images/vip-crown.png": "265a",
	"./theme_gold/images/vip-green-line.png": "c6ff",
	"./theme_gold/images/vip-roulette.png": "3807",
	"./theme_gold/images/vip-wallet.png": "9cc2",
	"./theme_gold/images/vip.png": "ab9f",
	"./theme_gold/images/vip0.png": "979b",
	"./theme_gold/images/vip1.png": "e5b1",
	"./theme_gold/images/vip2.png": "5b71",
	"./theme_gold/images/vip3.png": "8041",
	"./theme_gold/images/vip4.png": "52bf",
	"./theme_gold/images/vip5.png": "82d6",
	"./theme_gold/images/vip6.png": "b42d",
	"./theme_gold/images/vip7.png": "c1d2",
	"./theme_gold/images/vip8.png": "0ac6",
	"./theme_gold/images/vip_bg.png": "29c8",
	"./theme_gold/images/vip_gift_bg.png": "5e7b",
	"./theme_gold/images/wallet.png": "480d",
	"./theme_gold/images/web_TOP.png": "7399",
	"./theme_gold/images/wheel_2x.png": "598a",
	"./theme_green/images/1_gift.png": "d527",
	"./theme_green/images/2_gift.png": "b320",
	"./theme_green/images/3_gift.png": "2ec2",
	"./theme_green/images/4_gift.png": "f21e",
	"./theme_green/images/5_gift.png": "5766",
	"./theme_green/images/6_gift.png": "f5ef",
	"./theme_green/images/7_gift.png": "4727",
	"./theme_green/images/8_gift.png": "96e6",
	"./theme_green/images/9_gift.png": "25eb",
	"./theme_green/images/BackToTop.png": "32d1",
	"./theme_green/images/LogoLoading_circle01.png": "394f",
	"./theme_green/images/LogoLoading_circle02.png": "8d75",
	"./theme_green/images/LogoLoading_katsu.png": "7691",
	"./theme_green/images/bank-card.png": "23a8",
	"./theme_green/images/bank-promo.png": "7775",
	"./theme_green/images/ch_logo.png": "1fff",
	"./theme_green/images/completed.png": "8b68",
	"./theme_green/images/daily-attend.png": "b1a8",
	"./theme_green/images/db_gift_left.png": "9ae8",
	"./theme_green/images/db_gift_right.png": "f63e",
	"./theme_green/images/db_hero_img_mb.png": "4882",
	"./theme_green/images/db_hero_img_pc.png": "6447",
	"./theme_green/images/db_icon_coin.png": "6af4",
	"./theme_green/images/db_icon_lock.png": "c5a7",
	"./theme_green/images/en_logo.png": "fe97",
	"./theme_green/images/event.png": "2d34",
	"./theme_green/images/friend_promo.png": "a042",
	"./theme_green/images/giftbox.png": "0160",
	"./theme_green/images/home-arrow-left.png": "1227",
	"./theme_green/images/home-arrow-right.png": "521d",
	"./theme_green/images/icon-account.png": "606e",
	"./theme_green/images/icon-add.png": "3fbb",
	"./theme_green/images/icon-alert-kyc.png": "ff5d",
	"./theme_green/images/icon-alert.png": "592d",
	"./theme_green/images/icon-arrow-down-2.png": "cbb0",
	"./theme_green/images/icon-arrow-down-3.png": "cfd4",
	"./theme_green/images/icon-arrow-down-4-disabled.png": "c928",
	"./theme_green/images/icon-arrow-down-4.png": "85a3",
	"./theme_green/images/icon-arrow-down.png": "d382",
	"./theme_green/images/icon-arrow-dropdown.png": "44af",
	"./theme_green/images/icon-arrow-right.png": "6e6c",
	"./theme_green/images/icon-check-black.png": "11cc",
	"./theme_green/images/icon-check.png": "fcba",
	"./theme_green/images/icon-checked.png": "ae0e",
	"./theme_green/images/icon-close copy.png": "8e42",
	"./theme_green/images/icon-close-black.png": "e5ab",
	"./theme_green/images/icon-close.png": "4060",
	"./theme_green/images/icon-copy.png": "2440",
	"./theme_green/images/icon-date.png": "0913",
	"./theme_green/images/icon-detail.png": "e3a4",
	"./theme_green/images/icon-diamond.png": "6a69",
	"./theme_green/images/icon-download.png": "c1fa",
	"./theme_green/images/icon-favorite-active.png": "f654",
	"./theme_green/images/icon-favorite.png": "9199",
	"./theme_green/images/icon-filter.png": "1ee2",
	"./theme_green/images/icon-flag.png": "030e",
	"./theme_green/images/icon-game-search.png": "1fec",
	"./theme_green/images/icon-header-toggler.png": "c1e9",
	"./theme_green/images/icon-home.png": "43d2",
	"./theme_green/images/icon-info.png": "86f3",
	"./theme_green/images/icon-invite-promo.png": "11d6",
	"./theme_green/images/icon-invite-weekly.png": "2b38",
	"./theme_green/images/icon-kyc-add.png": "1b41",
	"./theme_green/images/icon-kyc-close.png": "db89",
	"./theme_green/images/icon-kyc-open.png": "a14f",
	"./theme_green/images/icon-lock.png": "4e20",
	"./theme_green/images/icon-member-active.png": "4437",
	"./theme_green/images/icon-member.png": "a5e2",
	"./theme_green/images/icon-nav-home.png": "63a3",
	"./theme_green/images/icon-notice.png": "62d9",
	"./theme_green/images/icon-password.png": "331c",
	"./theme_green/images/icon-phone-active.png": "8d03",
	"./theme_green/images/icon-phone.png": "65f0",
	"./theme_green/images/icon-real-name.png": "0ced",
	"./theme_green/images/icon-recommend.png": "24f8",
	"./theme_green/images/icon-refresh.png": "699a",
	"./theme_green/images/icon-register-success.png": "d638",
	"./theme_green/images/icon-search.png": "73cd",
	"./theme_green/images/icon-slot.png": "54fd",
	"./theme_green/images/icon-speaker.png": "c1cd",
	"./theme_green/images/icon-usdt.png": "26a8",
	"./theme_green/images/icon_allgames.png": "2be9",
	"./theme_green/images/icon_bell.png": "b5d8",
	"./theme_green/images/icon_check_white.png": "2284",
	"./theme_green/images/image-bank.png": "5bc4",
	"./theme_green/images/image-upload.png": "de0f",
	"./theme_green/images/japan.png": "8da7",
	"./theme_green/images/jp_logo.png": "1091",
	"./theme_green/images/login-left.png": "67cd",
	"./theme_green/images/mall-invite-image.png": "ae4b",
	"./theme_green/images/mall-product-image.png": "ef34",
	"./theme_green/images/my-account.png": "8bb2",
	"./theme_green/images/nav-bottom-deposit-active.png": "e3eb",
	"./theme_green/images/nav-bottom-deposit.png": "f868",
	"./theme_green/images/nav-bottom-home-active.png": "4284",
	"./theme_green/images/nav-bottom-home.png": "6c1a",
	"./theme_green/images/nav-bottom-my-active.png": "a36f",
	"./theme_green/images/nav-bottom-my.png": "28a2",
	"./theme_green/images/nav-bottom-offers-active.png": "1806",
	"./theme_green/images/nav-bottom-offers.png": "47cc",
	"./theme_green/images/nav-bottom-recommend-active.png": "1842",
	"./theme_green/images/nav-bottom-recommend.png": "2519",
	"./theme_green/images/new_guide.png": "311f",
	"./theme_green/images/no-data.png": "d531",
	"./theme_green/images/shop.png": "ca29",
	"./theme_green/images/stake-logo.png": "3a07",
	"./theme_green/images/terms-bg.png": "d670",
	"./theme_green/images/verify.png": "c15a",
	"./theme_green/images/vip-24-hours.png": "e658",
	"./theme_green/images/vip-arrow-left.png": "31f6",
	"./theme_green/images/vip-arrow-right.png": "2f3f",
	"./theme_green/images/vip-coin-stack.png": "5649",
	"./theme_green/images/vip-crown.png": "476b",
	"./theme_green/images/vip-green-line.png": "8f8b",
	"./theme_green/images/vip-roulette.png": "0272",
	"./theme_green/images/vip-wallet.png": "86c2",
	"./theme_green/images/wallet.png": "9e6b",
	"./theme_green/images/web_TOP.png": "4beb",
	"./theme_white/images/1_gift.png": "0a87",
	"./theme_white/images/2_gift.png": "fef5",
	"./theme_white/images/3_gift.png": "3684",
	"./theme_white/images/4_gift.png": "a033",
	"./theme_white/images/5_gift.png": "0457",
	"./theme_white/images/6_gift.png": "bdb0",
	"./theme_white/images/7_gift.png": "1c04",
	"./theme_white/images/8_gift.png": "0055",
	"./theme_white/images/9_gift.png": "504c",
	"./theme_white/images/BackToTop.png": "8da6",
	"./theme_white/images/Ellipse 264.png": "d2c2",
	"./theme_white/images/LogoLoading_circle01.png": "0b7d",
	"./theme_white/images/LogoLoading_circle02.png": "d1e2",
	"./theme_white/images/LogoLoading_katsu.png": "a3ce",
	"./theme_white/images/bank-card.png": "aad7",
	"./theme_white/images/bg_brush.png": "4296",
	"./theme_white/images/bg_repeat.png": "8a85",
	"./theme_white/images/bg_top.png": "b5e0",
	"./theme_white/images/ch_logo.png": "3d44",
	"./theme_white/images/completed.png": "0cca",
	"./theme_white/images/daily-attend.png": "8815",
	"./theme_white/images/db_gift_left.png": "2f48",
	"./theme_white/images/db_gift_right.png": "003f",
	"./theme_white/images/db_hero_img_mb.png": "f050",
	"./theme_white/images/db_hero_img_pc.png": "0934",
	"./theme_white/images/db_icon_coin.png": "716b",
	"./theme_white/images/db_icon_lock.png": "5640",
	"./theme_white/images/en_logo.png": "34a1",
	"./theme_white/images/event.png": "8ddd",
	"./theme_white/images/friend_promo.png": "5d3f",
	"./theme_white/images/giftbox.png": "d263",
	"./theme_white/images/home-arrow-left.png": "5b21",
	"./theme_white/images/home-arrow-right.png": "43ff",
	"./theme_white/images/icon-account.png": "ffa4",
	"./theme_white/images/icon-add.png": "89ac",
	"./theme_white/images/icon-alert-kyc.png": "f147",
	"./theme_white/images/icon-alert.png": "82b8",
	"./theme_white/images/icon-arrow-down-2.png": "6905",
	"./theme_white/images/icon-arrow-down-3.png": "c66a",
	"./theme_white/images/icon-arrow-down-4-disabled.png": "6835",
	"./theme_white/images/icon-arrow-down-4.png": "5d93",
	"./theme_white/images/icon-arrow-down.png": "7c3d",
	"./theme_white/images/icon-arrow-dropdown.png": "f038",
	"./theme_white/images/icon-arrow-right.png": "ac5a",
	"./theme_white/images/icon-check-black.png": "ae8c",
	"./theme_white/images/icon-check.png": "b48a",
	"./theme_white/images/icon-checked.png": "3097",
	"./theme_white/images/icon-close-black.png": "3934",
	"./theme_white/images/icon-close.png": "fd8d",
	"./theme_white/images/icon-close_index_phone.png": "b893",
	"./theme_white/images/icon-coin.png": "760a",
	"./theme_white/images/icon-copy.png": "1c61",
	"./theme_white/images/icon-crown.png": "9b32",
	"./theme_white/images/icon-date.png": "93e4",
	"./theme_white/images/icon-detail.png": "60f9",
	"./theme_white/images/icon-diamond.png": "3d17",
	"./theme_white/images/icon-download.png": "29fa",
	"./theme_white/images/icon-favorite-active.png": "2ac1",
	"./theme_white/images/icon-favorite.png": "832a",
	"./theme_white/images/icon-filter.png": "ed4e",
	"./theme_white/images/icon-flag.png": "344f",
	"./theme_white/images/icon-game-search.png": "1031",
	"./theme_white/images/icon-header-toggler.png": "bc75",
	"./theme_white/images/icon-home.png": "6685",
	"./theme_white/images/icon-info.png": "d465",
	"./theme_white/images/icon-invite-promo.png": "427a",
	"./theme_white/images/icon-invite-weekly.png": "e45f",
	"./theme_white/images/icon-kyc-add.png": "7f13",
	"./theme_white/images/icon-kyc-close.png": "d67b",
	"./theme_white/images/icon-kyc-open.png": "58ae",
	"./theme_white/images/icon-lock.png": "c456",
	"./theme_white/images/icon-member-active.png": "b19d",
	"./theme_white/images/icon-member.png": "5199",
	"./theme_white/images/icon-nav-home.png": "3ea2",
	"./theme_white/images/icon-notice.png": "d906",
	"./theme_white/images/icon-password.png": "a473",
	"./theme_white/images/icon-phone-active.png": "2d35",
	"./theme_white/images/icon-phone.png": "559b",
	"./theme_white/images/icon-real-name.png": "1829",
	"./theme_white/images/icon-recommend.png": "b735",
	"./theme_white/images/icon-refresh.png": "7849",
	"./theme_white/images/icon-register-success.png": "3a8d",
	"./theme_white/images/icon-search.png": "235e",
	"./theme_white/images/icon-slot-select.png": "f7c0",
	"./theme_white/images/icon-slot.png": "98c8",
	"./theme_white/images/icon-speaker.png": "1364",
	"./theme_white/images/icon-usdt.png": "d904",
	"./theme_white/images/icon_allgames.png": "e85e",
	"./theme_white/images/icon_bell.png": "7011",
	"./theme_white/images/icon_check_white.png": "cdbb",
	"./theme_white/images/image-bank.png": "e81f",
	"./theme_white/images/image-upload.png": "0b24",
	"./theme_white/images/japan.png": "a1dc",
	"./theme_white/images/jp_logo.png": "166a",
	"./theme_white/images/login-left.png": "631a",
	"./theme_white/images/mall-invite-image.png": "8b1d",
	"./theme_white/images/mall-product-image.png": "94dd",
	"./theme_white/images/my-account.png": "36ff",
	"./theme_white/images/nav-bottom-deposit-active.png": "41cb",
	"./theme_white/images/nav-bottom-deposit.png": "80a5",
	"./theme_white/images/nav-bottom-home-active.png": "0f40",
	"./theme_white/images/nav-bottom-home-mobile-index.png": "0318",
	"./theme_white/images/nav-bottom-home.png": "7481",
	"./theme_white/images/nav-bottom-my-active.png": "e55d",
	"./theme_white/images/nav-bottom-my.png": "572d",
	"./theme_white/images/nav-bottom-offers-active.png": "34a7",
	"./theme_white/images/nav-bottom-offers.png": "84ed",
	"./theme_white/images/nav-bottom-recommend-active.png": "4597",
	"./theme_white/images/nav-bottom-recommend.png": "49a6",
	"./theme_white/images/new_guide.png": "8fa4",
	"./theme_white/images/no-data.png": "8475",
	"./theme_white/images/rank-1st.png": "d1c4",
	"./theme_white/images/rank-2nd.png": "fbc5",
	"./theme_white/images/rank-3rd.png": "4fdb",
	"./theme_white/images/shop.png": "d48a",
	"./theme_white/images/stake-logo.png": "2d9f",
	"./theme_white/images/terms-bg.png": "2fd3",
	"./theme_white/images/title-championship.png": "f6c2",
	"./theme_white/images/verify.png": "f4db",
	"./theme_white/images/vip-24-hours.png": "186b",
	"./theme_white/images/vip-arrow-left.png": "c247",
	"./theme_white/images/vip-arrow-right.png": "500f",
	"./theme_white/images/vip-bg.png": "1ce5",
	"./theme_white/images/vip-coin-stack.png": "2c2c",
	"./theme_white/images/vip-crown.png": "1955",
	"./theme_white/images/vip-green-line.png": "780f",
	"./theme_white/images/vip-roulette.png": "4c2d",
	"./theme_white/images/vip-wallet.png": "7f48",
	"./theme_white/images/vip_gift_bg.png": "35e3",
	"./theme_white/images/wallet.png": "e166",
	"./theme_white/images/web_TOP.png": "3d6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e019";